module.exports = __webpack_public_path__ + "img/banner820.34b6788c.jpg";